import React from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import homeButton from 'assets/images/home-button.png';
import homeSelectedButton from 'assets/images/home-selected-button.png';
import ImageButton from './ImageButton';
import { AppRoutes } from '@monorepo/shared/src/types';

const t = (key: string) => translate('a11y', key);

const HomeButton: React.FC = () => {
  return (
    <ImageButton
      hoveredImgSrc={homeSelectedButton}
      notHoveredImgSrc={homeButton}
      imgAlt={t('alt.homeButton')}
      redirectRoute={{ path: `/${AppRoutes.HOME}`, title: AppRoutes.HOME }}
    />
  );
};

export default HomeButton;
